import { useLanguage, useTheme } from '@infominds/react-native-components'
import Color from 'color'
import Moment from 'moment'
import React, { useMemo, useState } from 'react'
import { Pressable, StyleSheet } from 'react-native'

import { Text, View } from '../components/Themed'
import Colors from '../constants/Colors'
import { Bill } from '../types'
import { PriceUtils } from '../utils/priceUtils'
import StateBadge from './StateBadge'

interface Props {
  item: Bill
  onPress: () => void
  onStatusPress: () => void
  isOthers: boolean
  isArchive: boolean
  isSelected: boolean
}
function ListItem({ item, onPress, onStatusPress, isOthers, isArchive, isSelected }: Props) {
  const { i18n, language } = useLanguage()
  const { colorScheme } = useTheme()

  const [state, setState] = useState<string | undefined>(undefined)
  const [other, setOther] = useState<boolean>(isOthers)

  /*
  console.log('others', other)
  console.log('state', state)
  console.log('otherEmployeesState', item.otherEmployeesState)
*/

  React.useEffect(() => {
    if (!isArchive) {
      setState('')
      setOther(false)
    } else {
      if (item.otherEmployeesState && item.otherEmployeesState !== 'UNDEF') {
        setState(item.otherEmployeesState)
        setOther(true)
      } else {
        setState(item.billState)
        setOther(false)
      }
    }
  }, [item])

  const color = useMemo(() => (colorScheme === 'light' ? Colors.light.listItemBackground : Colors.dark.listItemBackground), [colorScheme])
  const pressColor = useMemo(
    () =>
      colorScheme === 'light'
        ? Color(Colors.light.listItemBackground).darken(0.1).toString()
        : Color(Colors.dark.listItemBackground).lighten(0.5).toString(),
    [colorScheme]
  )

  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [
        {
          backgroundColor: pressed ? pressColor : color,
        },
        styles.item,
        isSelected && { borderColor: Colors.tint, borderLeftWidth: 5 },
      ]}>
      <View style={styles.itemcontainer}>
        <View style={styles.itemLeft}>
          <Text style={styles.title}>
            {item.billID} {i18n.t('ID_FROM')} {Moment(item.billDate).format('DD/MM/yyyy')}
          </Text>
          <Text lightColor={Colors.light.listItemDetail} darkColor={Colors.dark.listItemDetail}>
            {i18n.t('ID_TOTAL_SHORT')}: {PriceUtils.formatPrice(item.billAmount ?? 0, language, item.currency)} -{' ' + i18n.t('ID_DUEDATE_SHORT')}:{' '}
            {Moment(item.firstDueDate).format('DD/MM/yyyy')}
          </Text>
          <Text lightColor={Colors.light.listItemDetail} darkColor={Colors.dark.listItemDetail}>
            {item.supplierName}
          </Text>
        </View>
        <View style={styles.itemRight}>
          {state === '' && !isArchive ? (
            <View />
          ) : (
            <StateBadge state={state} onPress={onStatusPress} isOthers={other} hasComment={item.msgCount ? item.msgCount > 0 : false} />
          )}
        </View>
      </View>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  title: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  item: {
    margin: 1,
    fontSize: 18,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  itemcontainer: {
    margin: 1,
    padding: 10,
    fontSize: 18,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: 'transparent',
  },
  itemLeft: {
    width: '70%',
    backgroundColor: 'transparent',
  },
  itemRight: {
    margin: 5,
    alignSelf: 'flex-end',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
})

export default ListItem
